import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {IAppState} from '../models/IAppState';
import {filter, map, take} from 'rxjs/operators';
import {MemberType} from '../models/IUserData';


@Injectable({
  providedIn: 'root'
})
export class VisitorGuard implements CanActivate, CanActivateChild {
  private isVisitor$: Observable<MemberType> = this.store.select((state) => {
    if (state.AppStateReducer.userData) {
      return state.AppStateReducer.userData.memberType;
    } else {
      return null;
    }
  });

  constructor(
    private store: Store<{AppStateReducer: IAppState}>,
    private router: Router
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isVisitor$.pipe(
      filter((memberType: MemberType) => !!memberType),
      take(1),
      map((memberType: MemberType) => {
        if (memberType === MemberType.companyMember) {
          this.router.navigate(['/checkin-list/ticket'], {replaceUrl: true});
        } else if (memberType === MemberType.visitor) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.canActivate();
  }
}
